import { FunctionComponent, useState } from 'react'
import { AccessibilityType, Daycare } from '@/types/Daycare'
import styles from './daycareMerger.module.scss'
import profileStyles from '../DaycareProfileHandler.module.scss'
import AccessibilitiesLists from './accessibility/AccessibilitiesLists'
import DaycareMergerSettings from './settingsMerger/daycareMergerSettings'
import { useTranslation } from 'react-i18next'
import DaycareNoMergerSettings from './settingsNoMerger/settingsNoMerger'
import Title from '@/components/_custom/Title/title'
import ReservationSettings from './reservationSettings/reservationSettings'
import { useAuth } from '@/modules/context/AuthContext'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { CalendarMonth } from '@mui/icons-material'
import OtherReservationSettings from './otherReservationSettings/otherReservationSettings.tsx'

interface MergerProps {
    daycare: Daycare
}

const DaycareMerger: FunctionComponent<MergerProps> = ({ daycare }: MergerProps) => {
    const { t } = useTranslation()

    const navigate: NavigateFunction = useNavigate()

    const { user } = useAuth()

    const [mergerActive, setMergerActive] = useState<boolean>(daycare.merger)

    return (
        <div className={profileStyles.PagePosition}>
            {user?.currentDaycareRights.canWriteParamsDaycare && (
                <div className={styles.MergerPlacement}>
                    <ReservationSettings daycare={daycare} setMergerActive={setMergerActive} />
                </div>
            )}
            <div className={styles.MergerPlacement}>
                <div className={styles.Form}>
                    <div className={styles.TitleAndButton}>
                        <Title
                            text={mergerActive ? t('myFlexibleSettings') : t('myRestrictedSettings')}
                            className={styles.Title}
                        />
                    </div>
                    <div className={styles.Container}>
                        {!mergerActive ? (
                            <div className={styles.InputContainer}>
                                <DaycareNoMergerSettings
                                    daycare={daycare}
                                    disabled={!!user?.currentDaycareRights.canWriteParamsDaycare}
                                />
                            </div>
                        ) : (
                            <div className={styles.InputContainer}>
                                <DaycareMergerSettings
                                    disabled={!mergerActive || !user?.currentDaycareRights.canWriteParamsDaycare}
                                    daycare={daycare}
                                />
                                <div className={styles.AccessibilitiesInput}>
                                    <AccessibilitiesLists
                                        disabled={!mergerActive || !user?.currentDaycareRights.canWriteParamsDaycare}
                                        daycare={daycare}
                                        type={AccessibilityType.arrival}
                                        canUpdate={user?.currentDaycareRights.canWriteParamsDaycare || false}
                                    />
                                    <AccessibilitiesLists
                                        disabled={!mergerActive || !user?.currentDaycareRights.canWriteParamsDaycare}
                                        daycare={daycare}
                                        type={AccessibilityType.departure}
                                        canUpdate={user?.currentDaycareRights.canWriteParamsDaycare || false}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className={styles.MergerPlacement}>
                <OtherReservationSettings />
            </div>
            <div className={styles.PlanningButton}>
                <a
                    href={'/calendar'}
                    onClick={(e) => {
                        if (!(e.ctrlKey || e.metaKey)) {
                            e.preventDefault()
                            navigate('/calendar')
                        }
                    }}
                >
                    <ButtonTextIcon type={'custom'} customText={t('showPlanning')} customIcon={<CalendarMonth />} />
                </a>
            </div>
        </div>
    )
}

export default DaycareMerger
